import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';

import { DropdownFilter } from '../../Planner/Filters/DropdownFilter';
import ReasonContent from './ReasonContent';

export default function ReasonsPage() {
  document.title = 'Reasons';

  const [state, setState] = useState({
    options: [
      { id: 0, name: 'Cancellation Reasons' },
      { id: 1, name: 'Rescheduled Reasons' },
      { id: 2, name: 'Not Done Reasons' },
      { id: 3, name: 'Edit Treatment Reasons' },
    ],
    selectedReasonType: 0,
  });

  return (
    <React.Fragment>
      <section className="slick-page-header-section">
        <Box className="filter-section" display="flex" flexWrap="nowrap" p={0} justifyContent="flex-start" px={1}>
          <Box p={1}>
            <FilterListIcon style={{ color: '#8F8F8F', paddingTop: '3px' }} />
          </Box>
          <Box p={1} width={100}>
            <span style={{ fontSize: '14px', lineHeight: '30px' }}>Reason Type</span>
          </Box>
          <Box p={1} width={300}>
            <DropdownFilter
              data={state.options}
              defaultValue={[state.options[0].id]}
              filterKey={'reasons'}
              filterValue={state.selectedReasonType}
              onChange={(name, value) => setState({ ...state, selectedReasonType: value })}
            />
          </Box>
        </Box>
      </section>
      <ReasonContent reasonType={state.selectedReasonType} />
    </React.Fragment>
  );
}
